import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

import { CONTAINER_ID } from '../donate_v6/useEmployerMatching'

// Double the Donation's employer search. Bootstrap twin: donate_v6/EmployerMatching.jsx.

const HEADING_ID = 'employer-matching-heading'

const EmployerMatching = ({ i18n, employerMatching }) => {
  const { enabled, failed, loaded, companyName } = employerMatching

  useEffect(() => {
    if (enabled && !failed && loaded) employerMatching.init()
  }, [ loaded ])

  if (!enabled || failed) return null

  return (
    // aria-labelledby: the plugin injects its field after mount, so no <label>.
    <div
      role="group"
      aria-labelledby={HEADING_ID}
      className="employer-matching space-y-3 rounded-lg border border-brand-500 bg-brand-50 p-3 @roomy:p-4"
    >
      <header className="space-y-0.5 text-center">
        <h3 id={HEADING_ID} className="text-base font-semibold">
          {i18n.t('employer_matching.heading')}
        </h3>
        <p className="text-sm text-gray-500">
          {i18n.t('employer_matching.description')}
        </p>
      </header>
      <div id={CONTAINER_ID}></div>
      {/* The plugin's field remounts empty on every return to Start, so this
          confirms the pick. Mounted even when empty so AT announces the change. */}
      <p
        role="status"
        aria-live="polite"
        className={companyName
          ? 'text-sm font-medium flex items-center gap-2'
          : 'sr-only'}
      >
        {companyName && <>
          <FontAwesomeIcon icon={faCircleCheck} className="text-success-700" />
          {i18n.t('employer_matching.selected', { company: companyName })}
        </>}
      </p>
    </div>
  )
}

export default EmployerMatching
